<template>
  <div class="visitor-profile-desktop">
    <div class="visitor-profile-desktop-inner">
      <div
        class="visitor-profile-desktop-particle"
      />
      <div class="visitor-profile-desktop-avatar-wrapper">
        <img
          class="visitor-profile-desktop-avatar"
          :src="userAvatar"
          :alt="getUserData('name')"
        >
      </div>
      <div class="visitor-profile-desktop-data">
        <div class="visitor-profile-desktop-data-title-wrapper">
          <h2 class="visitor-profile-desktop-data-title">
            {{ getUserData('name') || $t('Agent') }}
          </h2>
        </div>
        <div class="visitor-profile-desktop-data-text-wrapper">
          <p class="visitor-profile-desktop-data-text">
            <i class="isif isif-brief-case" />
            <span class="visitor-profile-desktop-data-text-icon-divider" />
            <span class="visitor-profile-desktop-data-text-ellipsis">{{ getUserData('companyDisplayName') || $t('None') }}</span>
          </p>
          <p class="visitor-profile-desktop-data-text">
            <i class="isif isif-phone" />
            <span class="visitor-profile-desktop-data-text-icon-divider" />
            <span class="visitor-profile-desktop-data-text-ellipsis">{{ getUserData('phone') || $t('None') }}</span>
          </p>
          <p class="visitor-profile-desktop-data-text">
            <i class="isif isif-drawer" />
            <span class="visitor-profile-desktop-data-text-icon-divider" />
            <span class="visitor-profile-desktop-data-text-ellipsis">{{ getUserData('email') || $t('None') }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import defaultPersonaImage from '../img/default-persona.svg'

export default {
  name: 'VisitorProfileDesktop',
  data () {
    return {
      defaultPersonaImage
    }
  },

  computed: {
    ...mapGetters([
      'user'
    ]),

    userAvatar () {
      if (this.user.showAdminProfile && this.user.adminProfile) {
        return this.user.adminProfile.profileUrl || this.defaultPersonaImage
      } else {
        // if (_.has(this.user.portrait, 'cutUrl')) {
        //   return this.user.portrait.cutUrl
        // }
        return this.user.profileUrl || this.defaultPersonaImage
      }
    }
  },

  methods: {
    ...mapActions([
    ]),

    getUserData (key) {
      if (this.user.showAdminProfile && this.user.adminProfile) {
        return this.user.adminProfile[key] || ''
      } else {
        return this.user[key] || ''
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'
@import '~css/common/extends'

.visitor-profile-desktop {
  flex-shrink: 0;
  width: 414px;
  height: 520px;
  background-color: $white;
  border-top-left-radius: 4px; // 設計稿左上是有圓角的
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 0 60px 0 rgba(0, 0, 0, 0.5);
  overflow: auto;
}

.visitor-profile-desktop-particle {
  position: relative
  width: 100%;
  height: 183px;
  overflow: hidden;
  background-image: linear-gradient(to right, rgba(38, 38, 38, 0.85), rgba(180, 180, 180, 0.8));

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: embedurl('../img/particle.svg');
  }
}

.visitor-profile-desktop-avatar-wrapper {
  width: 200px;
  height: 200px;
  margin-top: -100px;
  margin-left: auto;
  margin-right: auto;
  opacity: .99;
}

.visitor-profile-desktop-avatar {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border-width: 1px;
  border-color: #d5d5d5;
  border-style: solid;
}

.visitor-profile-desktop-data-title-wrapper {
  position: relative
  margin-top: 20px
  margin-bottom: 3.5px;

  &::after {
    content: ''
    position: absolute
    bottom: 0
    left: calc(50% - 70px);
    width: 140px;
    height: 1px;
    background-color: $black;
  }
}

.visitor-profile-desktop-data-title {
  @extend .text-ellipsis;
  height: 33px;
  margin: 0 12px;
  font-size: 1.5rem;
  letter-spacing: 1.65px;
  text-align: center;
  color: $black;
  font-weight: 500;
  text-shadow: none;
}

.visitor-profile-desktop-data-text-wrapper {
  margin-top: 35px;
  margin-left: 25px;
  margin-right: 25px;

  .visitor-profile-desktop-data-text + .visitor-profile-desktop-data-text {
    margin-top: 12px;
  }
}

.visitor-profile-desktop-data-text {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 25px;
  text-align: justify;
  font-size: 1.125rem;
  letter-spacing: 1.5px;
  color: #637280;
  text-shadow: none;
  overflow: hidden;

  > * {
    flex-shrink: 0;
    color: inherit;
    text-shadow: inherit;
  }
}

.visitor-profile-desktop-data-text-ellipsis {
  @extend .text-ellipsis;
  width: calc(100% - 38px);
}

.visitor-profile-desktop-data-text-icon-divider {
  display: inline-block;
  width: 1px;
  height: 80%;
  background-color: #637280;
  margin: 0 9.5px;
}
</style>
